import React, { useRef, useState } from "react";
import { FormatLineSpacing } from "@mui/icons-material";
import Menu from "@mui/material/Menu";
import { MenuItem, ToggleButton } from "@mui/material";
import { useCurrentEditor } from "@tiptap/react";

export default function LineHeight() {
  const menuAnchor = useRef<HTMLButtonElement>(null);
  const [menuOpen, setMenuOpen] = useState(false);
  const { editor } = useCurrentEditor();

  if (!editor) {
    return null;
  }

  return (
    <ToggleButton
      value={""}
      selected={menuOpen}
      onChange={() => {
        setMenuOpen((prevState) => !prevState);
      }}
      ref={menuAnchor}
    >
      <FormatLineSpacing />
      <Menu
        open={menuOpen}
        onClose={(event: React.SyntheticEvent) => {
          setMenuOpen(false);
          event.stopPropagation();
        }}
        anchorEl={menuAnchor.current}
      >
        {["1.0", "1.15", "1.5", "2.0"].map((lineHeight) => (
          <MenuItem
            key={lineHeight}
            value={lineHeight}
            onClick={(event) => {
              editor.chain().focus().setLineHeight(lineHeight).run();
              setMenuOpen(false);
              event.stopPropagation();
            }}
          >
            {lineHeight}
          </MenuItem>
        ))}
      </Menu>
    </ToggleButton>
  );
}
